/**
 * Dispatch custom event globally
 */
export function Evnt_dispatch(name: string) {
    const event = document.createEvent('Event')
    event.initEvent(name, true, true)
    window.dispatchEvent(event)
}
